import css from 'styled-jsx/css'
import { iadProvitionalColors } from 'theme/colors'

export default css`
  .title {
    color: ${iadProvitionalColors.primary};
  }
`
